import { TRIPADD_VAS_TYPES } from 'components/trip-add'

export const getTotalTripAddAddonServicesPrice = (priceSummery = {}) => {
    return Object.entries(priceSummery)?.reduce((acc, [key, value = { amount: 0, label: '' }]) => {
        if (!key) return acc

        if (TRIPADD_VAS_TYPES.includes(key)) {
            //This is to handle the case  BAGGAGE_INSURANCE vasType can available in trip add and Other VAS-Provider
            if (typeof value === 'number' && key === 'BAGGAGE_INSURANCE') {
                return acc + value
            }
            if (typeof value === 'object') {
                const { amount = 0 } = value || {}
                return acc + amount
            }
        }

        return acc
    }, 0)
}
